import { PaymentMethodsGenericActions } from '../../../components/payment-methods/actions/actions-generic';
import { ContextToProps } from '../context-to-props';

export type PaymentMethodsDefaultListActionsProps = {
  shouldUsePadding?: boolean;
};

export const PaymentMethodsDefaultListActions = (props: PaymentMethodsDefaultListActionsProps) => {
  return (
    <ContextToProps.ListActions
      {...props}
      stripeComponent={PaymentMethodsGenericActions}
      justifiComponent={PaymentMethodsGenericActions}
    />
  );
};
